<template>
  <v-chip
    label
    class="pa-2"
    color="primary"
    text-color="white"
    style="width: 100px"
  >
    <v-layout row wrap class="pa-0" align-center justify-center>
      <v-flex xs12 class="text-xs-center">
        <strong>v{{ version }}</strong>
      </v-flex>
      <v-flex xs12 class="text-xs-center">
        {{ env }}
      </v-flex>
    </v-layout>
    <br />
  </v-chip>
</template>

<script>
import { globalData } from "@/providers/global";

export default {
  name: "version",
  data() {
    return {
      version: "",
      env: "",
    };
  },
  created() {
    this.version = globalData.$data.$appVersion;
    this.env = globalData.$data.$appMode == 1 ? "DEMO" : "PROD";
  },
};
</script>